import React from "react";
// Styles
import Styled from "./StatusCircle.styled";

const StatusCircle = ({ isActive, size = "18px", ...props }) => {
  return <Styled.StatusCircle isActive={isActive} size={size} {...props} />;
};

export default StatusCircle;
